import Splide from '@splidejs/splide';

function initSlider(el) {
    const sliderEl = el.querySelector('.splide');
    if (!sliderEl) {
        return;
    }

    new Splide(sliderEl, {
        lazyLoad: 'nearby',
        pagination: true,
        arrows: false,
        autoplay: true,
        type: 'loop',
    }).mount();
}

export default function initSliderGalleries() {
    const elements = document.querySelectorAll('.slider-gallery');

    elements.forEach(el => {
        initSlider(el);
    });
}
